/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S2_I1_TextInputs */

const tr_kullanim_s2_i1_text = /** @type {(inputs: Kullanim_S2_I1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shoppanel.emonse.com üzerinden sunulan yazılım hizmetleri`)
};

const en_kullanim_s2_i1_text = /** @type {(inputs: Kullanim_S2_I1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the software services provided via shoppanel.emonse.com`)
};

const de_kullanim_s2_i1_text = /** @type {(inputs: Kullanim_S2_I1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`die über shoppanel.emonse.com bereitgestellten Softwaredienste`)
};

const ru_kullanim_s2_i1_text = /** @type {(inputs: Kullanim_S2_I1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`программные услуги, предоставляемые через shoppanel.emonse.com`)
};

/**
* | output |
* | --- |
* | "the software services provided via shoppanel.emonse.com" |
*
* @param {Kullanim_S2_I1_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s2_i1_text = /** @type {((inputs?: Kullanim_S2_I1_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S2_I1_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s2_i1_text(inputs)
	if (locale === "de") return de_kullanim_s2_i1_text(inputs)
	if (locale === "ru") return ru_kullanim_s2_i1_text(inputs)
	return tr_kullanim_s2_i1_text(inputs)
});